import React from 'react';
import {CTAButton} from '@growcloud-io/dc/components/buttons/Buttons';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import {HeroPageItem} from "@growcloud-io/gcio-commons/common/components/PageComponents";

import {gcFrontPageContentData} from "./data/FrontPageData";
import {newColumnStack} from "@growcloud-io/gcio-commons/common/utils/UiUtils";
import {newStackSx} from '@growcloud-io/dc/util/StackUtils';

const frontPageData = gcFrontPageContentData()

export const FrontPage = ({}) => {
  return (
    <>
        <Stack direction="column" sx={newStackSx('center','center')}>
          <Box>
            <Typography
              variant="h6"
            >BETA PROGRAM</Typography>
          </Box>
          <Box>
            <CTAButton
              buttonColor="primary"
              buttonText={'ENQUIRE'}
              onClick={() => {
                window.location.href = `/enquiry`;
              }}
            />
          </Box>
      </Stack>

      <Stack direction={'column'} sx={newColumnStack()}>
        <HeroPageItem heroItemData={frontPageData["PlanYourProduction"]}/>
      </Stack>

      <Stack direction={'column'} sx={newColumnStack()}>
        <HeroPageItem heroItemData={frontPageData["MonitorYourProduction"]}/>
      </Stack>

      <Stack direction={'column'} sx={newColumnStack()}>
        <>SELECTED CASE STUDIES</>
        <CTAButton
          buttonColor="primary"
          buttonText={'VIEW ALL CASE STUDIES'}
          onClick={() => {
            window.location.href = `/resources#caseStudies`;
          }}
        />
      </Stack>


      <Stack direction={'column'} sx={newColumnStack()}>
        <>SELECTED GUIDES</>
        <CTAButton
          buttonColor="primary"
          buttonText={'VIEW ALL GUIDES'}
          onClick={() => {
            window.location.href = `/resources#guides`;
          }}
        />
      </Stack>
    </>
  );
}
